import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const renewConversationClaims = {
  name: "renewConversationClaims" as const,
  input: z.object({ conversationIds: z.array(zExt.objectId()) }),
  output: z.object({ lostIds: z.array(zExt.objectId()) }),
};
